import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-mist" data-id="element-137" data-mp="1o2vigsgkwt85">
      <div className="max-w-4xl mx-auto" data-id="element-138" data-mp="223em7ne0hd4i">
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-white border border-gold/50 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden shadow-lg shadow-ink/5" data-id="element-139" data-mp="222dbxl4tkunu">
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-forest border-2 border-gold text-gold-light mb-8" data-id="element-140" data-mp="1j4ah2pplc3i4">
            <ShieldCheck size={48} data-id="element-141" data-mp="1ed28fvw34m60" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-6 text-ink uppercase" data-id="element-142" data-mp="qnzq0ltmmpag">
            <span className="text-forest" data-id="element-143" data-mp="lpg2wi3ar7gi">7-Day</span> Guarantee
          </h2>
          <div className="space-y-6 text-lg text-graphite max-w-2xl mx-auto" data-id="element-144" data-mp="lnc1q7ws8mjx">
            <p data-id="element-145" data-mp="oz9kct34oxhv">
              Your purchase includes a 7-day guarantee for materials that are not delivered or are
              delivered incorrectly.
            </p>
            <p className="font-medium text-ink" data-id="element-146" data-mp="yp2ya0qqtopa">
              If you experience an eligible issue, contact our support team within the guarantee
              period so we can review your case and resolve the problem according to the applicable
              guarantee terms.
            </p>
            <p className="text-sm text-graphite/60 mt-8" data-id="element-147" data-mp="ayythq1tjiwp">All materials are delivered digitally.</p>
          </div>
        </motion.div>
      </div>
    </section>;
}